import React, { useState, useEffect } from "react";
import injectSheet from "react-jss";
import { NavLink } from "react-router-dom";
import {
  BookingIcon,
  DocumentIcon,
  EmailIcon,
  GroupIcon,
  //SettingsIcon,
} from "../../../assets/icons/Icons";

const SamverkanspartItems = ({
  datatype,
  toggleSubmenu,
  classes,
  userState,
}) => {
  const [hasLokalAdminPermission, setHasLokalAdminPermission] = useState(false);

  useEffect(() => {
    if (userState && userState.selectedSamverkanspart != null) {
      if (userState?.user?.avdelnings) {
        let s2 = userState?.user?.avdelnings.reduce(
          (prev, avd) =>
            prev ||
            avd.samverkansparts.find(
              (item) => item.id === userState.selectedSamverkanspart.id
            ),
          undefined
        );
        setHasLokalAdminPermission(s2 && s2.lokalbokare);
      }

      /* setHasLokalAdminPermission(
        userState?.user?.avdelnings?.some(
          (x) => x.externalUser && (x.permission & 128) === 128
        )
      ); */
    }
  }, [userState.selectedSamverkanspart]);

  return (
    <>
      <NavLink
        onClick={toggleSubmenu}
        data-tooltip-content="Hantera samverkanspartens dokument"
        data-tooltip-id="navbottom"
        data-place="right"
        data-tooltip-variant={datatype}
        to="/samverkansparts/document"
        className={classes.button}
      >
        <div>
          <div className={classes.iconStyle}>
            <DocumentIcon size="24px" color="white" />
          </div>
          <div>Dokument</div>
        </div>
      </NavLink>
      <NavLink
        onClick={toggleSubmenu}
        data-tooltip-content="Hantera arrangemang"
        data-tooltip-id="navright"
        data-place="right"
        data-tooltip-variant={datatype}
        to="/samverkansparts/event"
        className={classes.button}
      >
        <div>
          <div className={classes.iconStyle}>
            <GroupIcon size="24px" color="white" />
          </div>
          <div>Arrange&shy;mang</div>
        </div>
      </NavLink>
      <NavLink
        onClick={toggleSubmenu}
        data-tooltip-content="Hantera loggen"
        data-tooltip-id="navright"
        data-place="right"
        data-tooltip-variant={datatype}
        to="/samverkansparts/logg"
        className={classes.button}
      >
        <div>
          <div className={classes.iconStyle}>
            <EmailIcon size="24px" color="white" />
          </div>
          <div>Logg</div>
        </div>
      </NavLink>
      {hasLokalAdminPermission && (
        <NavLink
          onClick={toggleSubmenu}
          data-tooltip-content="Hantera lokalbokning"
          data-tooltip-id="navright"
          data-place="right"
          data-tooltip-variant={datatype}
          to="/booking/booking"
          //to="/samverkansparts/booking"
          className={classes.button}
        >
          <div>
            <div className={classes.iconStyle}>
              <BookingIcon size="24px" color="white" />
            </div>
            <div>Lokal&shy;bokning</div>
          </div>
        </NavLink>
      )}
      {/* <NavLink
        onClick={toggleSubmenu}
        data-tooltip-content="Hantera inställningar"
        data-tooltip-id="navright"
        data-place="right"
        data-tooltip-variant={datatype}
        to="/samverkansparts/settings"
        className={classes.button}
      >
        <div>
          <div className={classes.iconStyle}>
            <SettingsIcon size="24px" color="white" />
          </div>
          <div>Inställn&shy;ingar</div>
        </div>
      </NavLink> */}
    </>
  );
};

const styles = {
  iconStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "5px",
  },
  button: {
    wordBreak: "break-word !important",
    // display: "flex",
    // alignItems: "center",
    // justifyContent: "center",
    textAlign: "center",
    letterSpacing: "normal",
    fontWeight: "500",
    // wordBreak: "break-all",
    // lineHeight: "1.0",
  },
};

export default injectSheet(styles)(SamverkanspartItems);
